export default __webpack_public_path__ + "img/girassol.0f39214f.jpg";